import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid2,
  IconButton,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSelect from "../../../components/MasterSelect";
import colors from "../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../Utils/MessagePopup";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import { UserContext } from "../../../pages/usercontext/usercontext";
import { postItem, updateItem, fetchAll, fetchById, FetchDataGet } from "../../../BaseUrl";
import { GETCLIENT } from "../../Masters/ClientMaster/Mutation";
import { createuserstatus, updateuserstatus } from "../shortlisted/mutation";
import { getallpostion,getallpostionDropDown ,getallposittionbasedonClient } from "../../Masters/PositionMaster/mutation";
import { getFormattedStatus } from "../../Utils/getFormattedStatus";
import { Getalluserdetail, getClientsByUserId } from "../../Masters/UserMaster/mutation";

const AddShortlist = ({ formClose, editeddata, editedtrue, view }) => {
  const { isuser, user } = useContext(UserContext);

  const statusoptions = [
    { label: "Shortlisted", value: "shortlisted" },
    { label: "Not Shortlisted", value: "not_shortlisted" },
    { label: "Interviewed", value: "interviewed" },
  ];

  const [userdata, setuserdata] = useState({
    currentdate: "",
    hrname: "",
    candidatename: "",
    contactno: "",
    client: "",
    position: "",
    interviewdate: "",
    status: "",
    feedback: "",
    inviteLink: false,
    currentdateStatus: "unchecked",
    hrnameStatus: "unchecked",
    candidatenameStatus: "unchecked",
    contactnoStatus: "unchecked",
    clientStatus: "unchecked",
    positionStatus: "unchecked",
    interviewdateStatus: "unchecked",
    statusStatus: "unchecked",
    feedbackStatus: "unchecked",
    inviteLinkStatus: "unchecked",
  });
  // console.log("userdata", userdata);

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const [clientoptions, setclientoptions] = useState([]);
  const [positionoptions, setpositionoptions] = useState([]);
  const [editid, setEditid] = useState(0);


  useEffect(() => {
    getcurrentdate();
    getClientData();
  }, []);

  useEffect(() => {
    if (userdata.client !== "" && userdata.client !== undefined) {

      getAllposition(userdata.client.value);
    }
  }, [userdata]);

  useEffect(() => {
    if ((editedtrue === true || view === true) && clientoptions.length > 0) {
      getdataforEdit();
      getcurrentdate();
    }
  }, [editedtrue, clientoptions]);

  const getdataforEdit = async () => {
    const editedItem = editeddata[0];

    const matchedStatus = {
      label: getFormattedStatus(editedItem?.status),
      value: editedItem.status.toLowerCase(),
    };

    const matchedClient = clientoptions.find(
      (client) => client.value === editedItem.clientId
    );

    const formatDate = (isoDate) => {
      if (!isoDate) return "";
      const [day, month, year] = isoDate.split("-");
      return `${year}-${month}-${day}`;
    };

    setTimeout(() => {
      setuserdata({
        ...userdata,
        currentdate: formatDate(editedItem?.shortlistedDate),
        hrname: editedItem?.createdBy,
        candidatename: editedItem.candidateName,
        contactno: editedItem.candidateNumber,
        client: matchedClient,
        position: {
          label: editedItem.positionName,
          value: editedItem.positionId,
        },
        interviewdate: formatDate(editedItem.interviewDate),
        status: matchedStatus,
        feedback: editedItem.shortlistFeedback,
        currentdateStatus: "success",
        hrnameStatus: "success",
        candidatenameStatus: "success",
        contactnoStatus: "success",
        clientStatus: "success",
        positionStatus: "success",
        interviewdateStatus: "success",
        statusStatus: "success",
        feedbackStatus: "success",
      });
      setEditid(editedItem.id);
    }, 500);

  };



  const getcurrentdate = () => {
    const today = new Date().toISOString().split("T")[0];
    setuserdata({
      ...userdata,
      currentdate: today,
      currentdateStatus: "success",
    });
  };

  // const getClientData = async () => {
  //   try {
  //     const response = await fetchAll(GETCLIENT);
  //     if (response?.getAllClients?.success === true) {
  //       const data = response?.getAllClients?.data.map((v, i) => ({
  //         value: v?.id,
  //         label: v?.clientName,
  //         address: v?.address,
  //         mapLocation: v?.mapLocation,
  //         contactperson: v?.primaryContactPerson,
  //       }));
  //       setclientoptions(data);
  //     } else {
  //       setclientoptions([]);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //   }
  // };

  const getClientData = async () => {
    try {

      const variables = { userDetailId: isuser?.userid };
      const response = await fetchById(getClientsByUserId, variables);
      // console.log("response", response);

      if (response?.getClientsByUserDetailId?.success) {
        const options = response?.getClientsByUserDetailId?.data.map((v, i) => ({
          value: v?.id,
          label: v?.clientName,
          address: v?.address,
          mapLocation: v?.mapLocation,
          contactperson: v?.primaryContactPerson
        }));
        setclientoptions(options);
      }
      else {
        setclientoptions([]);
      }

    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const getAllposition = async (id) => {
    try {
     
      const variables = {
        clientId: Number(id),
      };
    
      const response = await FetchDataGet(getallposittionbasedonClient,variables);
      if (response?.getPositionsByClient?.success === true) {
        const data = response?.getPositionsByClient?.data
          ?.filter((v) => v?.client?.id === id)
          .map((v, i) => ({
            value: v?.id,
            label: v?.positionName,
          }));
        setpositionoptions(data);
      } else {
        setpositionoptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...userdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "client") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "position") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "status") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
          if (event?.value === "interviewed") {
            formState["feedback"] = "";
            formState["feedbackStatus"] = "unchecked";
          } else if (editeddata.length > 0) {
            formState["feedback"] = editeddata[0]?.shortlistFeedback;
            formState["feedbackStatus"] = "success";
          }
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "candidatename":
          {
            const alphaNLengthRegex = new RegExp("^[a-zA-Z ]{1,20}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "feedback":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactno":
          {
            const alphaNLengthRegex = new RegExp("^.{10,10}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "interviewdate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "inviteLink":
          {
            const isChecked = event.target.checked;
            formState[event.target.name] = isChecked;
            formState[event.target.name + "Status"] = "success";
          }
          break;
        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] =
          event.target.type === "checkbox"
            ? event.target.checked
            : event.target.value;
      }
    }
    setuserdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };
  const hanldeConfirmDialogSubmit = async () => {
    try {
      if (editid == 0) {
        const variables = {
          input: {
            candidateNumber: userdata.contactno,
            candidateName: userdata.candidatename,
            client: userdata.client.value,
            position: userdata.position.value,
            commitmentDate: userdata.interviewdate,
            shortlistedDate: userdata.currentdate,
            interviewDate: userdata.interviewdate,
            hrUser: isuser.userid,
            status: userdata.status.value,
            shortlistFeedback: userdata.feedback,
            interviewFeedback: editedtrue ? userdata.feedback : "",
            createdBy: isuser.username,
          },
        };
        const response = await postItem(createuserstatus, variables);
        // console.log("userdata", userdata);
        // console.log("response", response);


        if (response.createScreening.success == true) {
          if (userdata.inviteLink === true) {
            const phoneNumber = userdata.contactno; // Replace with the target phone number
            const message = encodeURIComponent(
              `Dear ${userdata.candidatename},
Congratulations, Upon reviewing your application, we would like to invite you for Direct interview and get to know you better.
 
*Please write your resume:
Reference: Takecare Manpower Services Pvt Ltd*

Client Name: ${userdata.client.label}

Position: ${userdata.position.label}

Interview Date: ${userdata.interviewdate}

Interview Time: 10:30
 
Interview venue: ${userdata.client?.address}

Map Location : ${userdata.client?.mapLocation}

Contact Person : ${userdata.client?.contactperson}
 
Please Let me know when you arrive at the interview location.
All the best....
 
Regards
${isuser.username}
`
            ); // Optional message
            const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

            // Open WhatsApp URL in a new tab
            window.open(whatsappUrl, "_blank");
          }
          setPopup({
            ...popup,
            open: true,
            message: response.createScreening.message,
            severity: "success",
          });
          setDialogOpen(false);
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.createScreening.message,
            severity: "error",
          });
          setDialogOpen(false);
        }
      } else {
        const variables = {
          input: {
            id: editid,
            candidateNumber: userdata.contactno,
            candidateName: userdata.candidatename,
            client: userdata.client.value,
            position: userdata.position.value,
            commitmentDate: userdata.interviewdate,
            shortlistedDate: userdata.currentdate,
            interviewDate: userdata.interviewdate,
            hrUser: isuser.userid,
            status: userdata.status.value,
            shortlistFeedback: userdata.feedback,
            interviewFeedback:
              userdata.status.value === "interviewed" ? userdata.feedback : "",
            updatedBy: isuser.username,
          },
        };
        const response = await updateItem(updateuserstatus, variables);
        if (response.updateScreening.success == true) {
          if (userdata.inviteLink === true) {
            const phoneNumber = userdata.contactno; // Replace with the target phone number
            const message = encodeURIComponent(
              `Dear ${userdata.candidatename},
Congratulations, Upon reviewing your application, we would like to invite you for Direct interview and get to know you better.
 
*Please write your resume:
Reference: Takecare Manpower Services Pvt Ltd*

Client Name: ${userdata.client.label}

Position: ${userdata.position.label}

Interview Date: ${userdata.interviewdate}

Interview Time: 10:30
 
Interview venue: ${userdata.client?.address}

Map Location : ${userdata.client?.mapLocation}

Contact Person : ${userdata.client?.contactperson}
 
Please Let me know when you arrive at the interview location.
All the best....
 
Regards
${isuser.username}`
            ); // Optional message
            const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

            // Open WhatsApp URL in a new tab
            window.open(whatsappUrl, "_blank");
          }
          setPopup({
            ...popup,
            open: true,
            message: response.updateScreening.message,
            severity: "success",
          });
          setDialogOpen(false);
          setTimeout(() => {
            reset();
          }, 1000);
        } else {
          setPopup({
            ...popup,
            open: true,
            message: response.updateScreening.message,
            severity: "error",
          });
          setDialogOpen(false);
        }
      }
    } catch (error) {
      console.error(error, "error");
      setPopup({
        ...popup,
        open: true,
        message: "error in saving or updating the details",
        severity: "error",
      });
      setDialogOpen(false);
    } finally {
    }
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setuserdata({
      ...userdata,
      currentdate: "",
      hrname: "",
      candidatename: "",
      contactno: "",
      client: "",
      position: "",
      interviewdate: "",
      status: "",
      feedback: "",
      inviteLink: "",
      currentdateStatus: "unchecked",
      hrnameStatus: "unchecked",
      candidatenameStatus: "unchecked",
      contactnoStatus: "unchecked",
      clientStatus: "unchecked",
      positionStatus: "unchecked",
      interviewdateStatus: "unchecked",
      statusStatus: "unchecked",
      feedbackStatus: "unchecked",
      inviteLinkStatus: "unchecked",
    });
    formClose();
    getcurrentdate();
  };


  const isFormValid = () => {
    return (
      userdata.currentdateStatus === "success" &&
      userdata.candidatenameStatus === "success" &&
      userdata.contactnoStatus === "success" &&
      userdata.clientStatus === "success" &&
      userdata.positionStatus === "success" &&
      userdata.interviewdateStatus === "success" &&
      userdata.statusStatus === "success" &&
      userdata.feedbackStatus === "success"
    );
  };


  // const view = true; 


  // const editedtrue = true;


  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        {/* <Loader isLoading={isLoading} /> */}
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              {editedtrue ? "Edit" : view ? "View" : "Add"} Candidate
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Current Date field
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="currentdate"
              placeholder="Enter DOB"
              type="date"
              value={userdata.currentdate}
              disabled={true}
              onChange={handleAddCourseChange}
              error={userdata.currentdateStatus === "error" ? true : false}
              success={userdata.currentdateStatus === "success" ? true : false}
            />
            {userdata.currentdateStatus === "error" && (
              <MaterialTypography

                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Current Date Should be DD-MM-YYYY.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              HR Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>

            </MaterialTypography>
            <MaterialInput
              name="hrname"
              placeholder="Enter HR Name"
              value={view || editedtrue ? userdata?.hrname : isuser?.username}
              onChange={handleAddCourseChange}
              error={userdata.hrnameStatus === "error" ? true : false}
              success={userdata.hrnameStatus === "success" ? true : false}
              disabled

            />

            {userdata.hrnameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                HR Name must be 1 to 20 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Candidate Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="candidatename"
              placeholder="Enter Candidate Name"
              value={userdata.candidatename}
              onChange={handleAddCourseChange}
              error={userdata.candidatenameStatus === "error" ? true : false}
              success={
                userdata.candidatenameStatus === "success" ? true : false
              }
              disabled={view}
            />
            {userdata.candidatenameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Candidate Name must be 1 to 20 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Contact Number
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="contactno"
              placeholder="Enter Contact Number"
              value={userdata.contactno}
              onChange={(event) => {
                const value = event.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  handleAddCourseChange(event, null); // Call handler only if valid
                }
              }}
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Tab",
                ];
                const isNumericKey = /^[0-9]$/.test(event.key);
                if (
                  (!isNumericKey && !allowedKeys.includes(event.key)) ||
                  (userdata.contactno &&
                    userdata.contactno.length >= 10 &&
                    isNumericKey)
                ) {
                  event.preventDefault(); // Prevent invalid or extra digits
                }
              }}
              error={userdata.contactnoStatus === "error" ? true : false}
              success={userdata.contactnoStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.contactnoStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Contact number should be 10 numeric characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Client
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="client"
              placeholder={`Select Client`}
              value={userdata.client}
              options={clientoptions}
              searchable={false}
              onChange={(selectedOption) => {
                handleAddCourseChange(selectedOption, { name: "client" });
                setuserdata((prev) => ({
                  ...prev,
                  position: "",
                  positionStatus: "unchecked",
                }));
              }}
              error={userdata.clientStatus === "error" ? true : false}
              success={userdata.clientStatus === "success" ? true : false}
              isDisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Position
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="position"
              placeholder={`Select Postion`}
              value={userdata.position}
              options={positionoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.positionStatus === "error" ? true : false}
              success={userdata.positionStatus === "success" ? true : false}
              isDisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Interview Date
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="interviewdate"
              placeholder="Enter DOB"
              type="date"
              value={userdata.interviewdate}
              onChange={handleAddCourseChange}
              error={userdata.interviewdateStatus === "error" ? true : false}
              success={
                userdata.interviewdateStatus === "success" ? true : false
              }
              disabled={view}
            />
            {userdata.interviewdateStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Interview date Should be DD-MM-YYYY.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Status
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="status"
              placeholder={`Select Status`}
              value={userdata.status}
              options={statusoptions}
              searchable={false}
              onChange={handleAddCourseChange}
              error={userdata.statusStatus === "error" ? true : false}
              success={userdata.statusStatus === "success" ? true : false}
              isDisabled={view}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Feedback
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="feedback"
              placeholder="Enter Feedback"
              value={userdata.feedback}
              onChange={handleAddCourseChange}
              error={userdata.feedbackStatus === "error" ? true : false}
              success={userdata.feedbackStatus === "success" ? true : false}
              disabled={view}
            />
            {userdata.feedbackStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Feedback should 1 to 30 Variable characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormControlLabel
              control={
                <Checkbox
                  name="inviteLink"
                  checked={userdata.inviteLink}
                  onChange={handleAddCourseChange}
                  color="primary"
                />
              }
              label="Invite Link"
              sx={{
                color: colors.inputlabel,
                fontWeight: "bold",
                mt: 4,
                ml: 1.5,
              }}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {!view && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  {editedtrue ? "Update" : "Submit"}
                </MaterialButton>
              )}
              <MaterialButton onClick={reset} variant="outlined" color="error">
                {view ? "Back" : "Cancel"}
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default AddShortlist;
